import './month-selector.scss';

import gazelleAnalytics from '../../core/analytics/analytics.module';

import * as gzMonthSelectorDirective from './month-selector.directive';
import * as changeDates from './change_dates.controller';

export default angular.module('gazelle.components.monthSelector', [
  'angularMoment',
  gazelleAnalytics
])
  .directive(gzMonthSelectorDirective.name, gzMonthSelectorDirective.default)
  .controller(changeDates.name, changeDates.default)
  .name;
